module.exports = "<span class=mui-label-desc><slot></slot></span>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inline-desc/index.vue
 ** module id = 163
 ** module chunks = 0
 **/